import { type ObjectValuesUnionType } from '../utils/typing';

export const OutcomeModes = Object.freeze({
  PLAY: 'PLAY',
  PAUSE: 'PAUSE',
  STOP_BUT_DISPLAYED: 'STOP_BUT_DISPLAYED',
  STOP: 'STOP',
  MY_MATCH_ANY_ERROR: 'MY_MATCH_ANY_ERROR',
});

export type OutcomeMode = ObjectValuesUnionType<typeof OutcomeModes>;
